<template>
    <v-row justify="center">
        <v-col cols="auto" class="pa-0">
            <v-switch :input-value="value.isDone" @change="toggleIsDone()" hide-details dense class="ma-0 pa-0" />
        </v-col>
    </v-row>
</template>

<script>
import api from "@/api";
export default {
    props: ["value"],
    methods: {
        async toggleIsDone() {
            try {
                const { _id, isDone } = this.value;
                const { counselRequest } = await api.console.counsels.put({ _id, isDone: !isDone });
                this.$emit("input", counselRequest);
                alert("변경되었습니다.");
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style></style>
